import * as React from 'react';
import { usePostMessageContext } from 'src/providers/PostMessageProvider';
import { useEffectOnce } from './useEffectOnce';

export function useInitializedEvent(data: object, callback?: () => void): boolean {
  const { postMessage } = usePostMessageContext();
  const [initialized, setInitialized] = React.useState(false);

  useEffectOnce(() => {
    setInitialized(true);
    // Send the initialized event
    postMessage('initialized', data);
    if (callback) {
      callback();
    }
  });

  return initialized;
}
